export function urlEncode(object) {
    return Object.keys(object)
        .map(function (key) { return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(object[key])); })
        .join("&");
}
//# sourceMappingURL=url.js.map